import VueStorage from 'vue-ls';

export default ({ Vue, config }) => {
  Vue.use(VueStorage, config.storageOptions);
};



// WEBPACK FOOTER //
// ./src/plugins/vue-storage.js